import React, { useState }  from 'react'
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Button } from '@mui/material';
import HistoryMedicalPDF from './HistoryMedicalPDF';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import RecetarioPDF from './RecetarioPDF';
import ProcedimientosPDF from './ProcedimientosPDF';
import RemisionesPDF from './RemisionesPDF';
import ImageDiagnosesPDF from './ImageDiagnosesPDF';
import LaboratoriosPDF from './LaboratoriosPDF';
import BartheyInfoPDF from './BartheyInfoPDF';
import HistoryTherapyPDF from './HistoryTherapyPDF';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import 'moment/locale/es';
import HistorySocialWorkerPDF from './HistorySocialWorkerPDF';
import HistoryNursePDF from './HistoryNursePDF';
import HistoryEmpresaLaboralPDF from './HistoryEmpresaLaboralPDF';
import IncapacidadPDF from './IncapacidadPDF';



export default function CloseHistory(props) {
  const [body, setBody] = useState("0");
  const handleChange = e => {
    setBody(e.target.value);
}

const isTherapy = (type) => {
  return (type == "Fisioterapia" || type == "Fonoaudiologia" 
           || type == "Terapia ocupacional" || type == "Psicología"
          ||  type == "SST OCUPACIONAL")
}


const getActionPDF = () => {
  switch(body) {
    case "0":
      if(isTherapy(props.affiliateInfo.type)) {
        return <HistoryTherapyPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>
      } else if((props.affiliateInfo.type == "Trabajadora Social")) {
        return <HistorySocialWorkerPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>;
      } else if((props.affiliateInfo.type == "Enfermeria")) {
        return <HistoryNursePDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>;
      } else if((props.affiliateInfo.type == "Medicina Laboral")) {
        return <HistoryEmpresaLaboralPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>;
      } else {
        return <HistoryMedicalPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution} 
                printAdditionalInfo={props.printAdditionalInfo}/>;
      }
    case "1": return <RecetarioPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution} 
                printAdditionalInfo={props.printAdditionalInfo}/>;
    case "2": return <RemisionesPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}
                printAdditionalInfo={props.printAdditionalInfo} />;
    case "3": return <LaboratoriosPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}
                printAdditionalInfo={props.printAdditionalInfo}/>;
    case "4": return <ProcedimientosPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}
                printAdditionalInfo={props.printAdditionalInfo}/>;
    case "5": return <ImageDiagnosesPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}
                printAdditionalInfo={props.printAdditionalInfo}/>;
    case "6": return <BartheyInfoPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>;
    case "7": return <IncapacidadPDF affiliateInfo={props.affiliateInfo} indexEvolution={props.indexEvolution}/>;
 
  }
}

  const getFileName = () => {
    switch(body) {
      case "0":  let dateAttend = props.printAdditionalInfo ? props.affiliateInfo.additionalsInfo[props.indexEvolution].assessmentDate 
              : props.affiliateInfo.evolutions[props.indexEvolution].assessmentDate;
              //: props.affiliateInfo?.evolutionsNutricionist[props.indexEvolution].assessmentDate;
          let patientName =  props.affiliateInfo.patient.firstName + " "  +
          `${props.affiliateInfo.patient.secondName || ''}` + " "  +
           props.affiliateInfo.patient.lastName + " "  +
          `${props.affiliateInfo.patient.secondLastName || ''}`;
          return "HC_" + patientName + "_" + moment(dateAttend).locale('es').format('MMMM D YYYY');
    
      case "1": return "RECETARIO.pdf";
      case "2": return "REMISION_DE_SERVICIOS.pdf";
      case "3": return "ORDEN_LABORATORIO.pdf";
      case "4": return "ORDEN_DE_PROCEDIMIENTO.pdf";
      case "5": return "ORDEN_DIAGNOSTICAS.pdf";
      case "6": return "CERTIFICADO_FUNCIONAL.pdf"
      case "7": return "INCAPACIDAD_2.pdf"
    }
  }
  return (

    <div>
      <Grid container>
        <Grid item xs={12} sm={6} md={4} className="header">
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Descargas de Formatos</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="0"
              name="radio-buttons-group"
              onChange={handleChange}
            >
              <FormControlLabel value="0" control={<Radio />} label="Historia Clinica" />
              <FormControlLabel value="1" hidden={isTherapy(props.affiliateInfo.type) } control={<Radio />} label="Recetario" />
              <FormControlLabel value="2" hidden={isTherapy(props.affiliateInfo.type) } control={<Radio />} label="Remisiones" />
              <FormControlLabel value="3" hidden={isTherapy(props.affiliateInfo.type) || props.affiliateInfo.type == "Medicina Laboral"} control={<Radio />} label="Laboratorios" />
              <FormControlLabel value="4" hidden={isTherapy(props.affiliateInfo.type) || props.affiliateInfo.type == "Medicina Laboral"} control={<Radio />} label="Procedimientos" />
              <FormControlLabel value="5" hidden={isTherapy(props.affiliateInfo.type) || props.affiliateInfo.type == "Medicina Laboral"} control={<Radio />} label="Imagenes Diagnosticas" />
              <FormControlLabel value="6" hidden={isTherapy(props.affiliateInfo.type) || props.affiliateInfo.type == "Medicina Laboral"} control={<Radio />} label="Certificado Funcional" />
              <FormControlLabel value="7" hidden={props.affiliateInfo.type != "Medicina Laboral"} control={<Radio />} label="Incapacidad" />
              
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="header">
          <PDFDownloadLink document={getActionPDF()} fileName={getFileName()}>
            <Button variant="contained">Descargar</Button>
          </PDFDownloadLink>
        </Grid>
      </Grid>
    </div>
  );
};